<div class="modal-form modal-data-act" *ngIf="showModal" (click)="closeModal($event)">
  <div class="modal-form-dialog">
    <div class="modal-header border-0">
        <span aria-label="Zamknij" (click)="closeModal($event)">
          <span class="icon-x"></span>
        </span>
    </div>
    <div class="modal-data-act-body">
      <div class="container px-3">
        <div class="row">
          <div class="col-12 data-act-body-headline">
            ROZPORZĄDZENIE 2023/2854 (DATA ACT)
          </div>
        </div>
      </div>
      <div class="container px-3">
        <div class="row">
          <p>
            <strong>Unijne rozporządzenie Data Act (Rozporządzenie Parlamentu Europejskiego i Rady UE 2023/2854)</strong> to europejska regulacja ustanawiająca zharmonizowane zasady dotyczące sposobu uzyskiwania dostępu do danych wygenerowanych przez usługi łączności i usługi cyfrowe, a także udostępniania ich i wykorzystywania. Celem tego Rozporządzenia jest zapewnienie Użytkownikowi większej kontroli nad danymi generowanymi przez pojazd, przy jednoczesnym zapewnieniu przejrzystości, sprawiedliwości i bezpieczeństwa w zakresie zarządzania danymi.
          </p>
        </div>
        <div class="row">
          <h2>Kim jest Użytkownik? </h2>
          <p>
            Użytkownik to osoba mająca stałe prawo do korzystania z usług łączności (np. właściciel lub osoba, której prawo do korzystania z pojazdu zostało przyznane w oparciu o umowę, np. najmu lub leasingu, lub osoba, która podpisała umowę o usługach łączności lub aktywowała konto w oficjalnej aplikacji lub za pośrednictwem strony internetowej marki Stellantis).
          </p>
        </div>
        <div class="row">
          <h2>Prawa przysługujące Użytkownikowi pojazdu</h2>
          <p>
            Kiedy Użytkownik korzysta z usług łączności w pojeździe Stellantis, dane są generowane i przesyłane w czasie rzeczywistym.
            Zgodnie z Rozporządzeniem Data Act, jako Użytkownik masz prawo do:
          </p>
          <ul>
            <li>
              <strong>dostępu</strong> do danych generowanych przez pojazd w standardowym, możliwym do wykorzystania formacie (na przykład JSON lub innym kompatybilnym);
            </li>
            <li>
              <strong>bycia informowanym</strong> o tym, jakie dane są gromadzone oraz jak i w jakim celu są wykorzystywane;
            </li>
            <li>
              <strong>decydowania</strong>, czy chcesz udostępniać Twoje dane stronom trzecim, np. warsztatom, ubezpieczycielom czy dostawcom usług cyfrowych;
            </li>
            <li>
              <strong>zarządzania</strong> swoimi wnioskami o dostęp do danych za pośrednictwem dedykowanych kanałów cyfrowych Stellantis.
            </li>
          </ul>
        </div>
        <div class="row">
          <h2>Dane generowane przez pojazdy podłączone z funkcjami łączności</h2>
          <p>Zależnie od sposobu korzystania z pojazdu z usługami łączności urządzenie pokładowe może gromadzić i przesyłać:</p>
          <ul>
            <li>
              <strong>dane diagnostyczne:</strong> temperatura silnika, poziom oleju, kody błędu;
            </li>
            <li>
              <strong>dane dotyczące użycia:</strong> przebieg, prędkość, czas jazdy, użycie systemów wspomagania kierowcy ADAS;
            </li>
            <li>
              <strong>dane lokalizacyjne:</strong> gdy włączony jest sygnał GPS;
            </li>
            <li>
              <strong>dane dotyczące interakcji:</strong> nawigacja, polecenia głosowe, użycie usług łączności;
            </li>
            <li>
              <strong>dane dotyczące zdarzeń:</strong> wykryte kolizje lub awarie.
            </li>
            <small>
              Ilość danych jest różna w zależności od sposobu korzystania z usług łączności w pojeździe.
            </small>
          </ul>
        </div>
        <div class="row">
          <h2>Cele przetwarzania danych</h2>
          <p>Stellantis przetwarza dane pojazdu wyłącznie w celu:</p>
          <ul>
            <li>
              <strong>dostarczania</strong> aktywowanych przez Użytkownika usług łączności i zarządzania nimi;
            </li>
            <li>
              <strong>wypełniania</strong> zobowiązań prawnych;
            </li>
            <li>
              <strong>poprawiania</strong> jakości i wydajności pojazdów i usług;
            </li>
            <li>
              <strong>analizowania</strong> zagregowanych i zanonimizowanych danych w celach statystycznych czy rozwijania produktów.
            </li>
          </ul>
        </div>
        <div class="row">
          <h2>Jak uzyskać dostęp do swoich danych?</h2>
          <p><strong>Użytkownicy bezpośredni, konsumenci (B2C):</strong> Użytkownicy bezpośredni mogą uzyskiwać dostęp za pośrednictwem <a href="https://privacyportal.stellantis.com/" target="_blank">Portalu Ochrony Danych Stellantis</a> w części „Prawo dostępu”; </p>
          <p><strong>Klienci korporacyjni (B2B):</strong> Użytkownicy korporacyjni (floty, firmy leasingowe, klienci komercyjni) muszą wysyłać swoje żądania dostępu do danych za pośrednictwem specjalnego kanału Mobilisights: <a href="https://www.mobilisights.com/en/contact-us.html" target="_blank">Formularz kontaktowy Mobilisights.</a></p>
        </div>
        <div class="row">
          <h2>Czy dostęp do danych Użytkownika mogą uzyskiwać strony trzecie?</h2>
          <p>Tak, ale tylko jeśli Użytkownik udzieli na to zgody. Użytkownik może wyrazić zgodę na dostęp strony trzeciej (na przykład warsztatu, ubezpieczyciela lub dostawcy usług) do jego danych na warunkach określonych w rozporządzeniu Data Act. </p>
        </div>
        <div class="row">
          <h2>Jak długo Użytkownik będzie mieć dostęp do swoich danych?</h2>
          <p>Dostęp do danych przechowywanych na serwerach Stellantis można uzyskiwać zgodnie z polityką przechowywania danych Grupy Stellantis. </p>
        </div>
        <div class="row">
          <h2>Czy rozporządzenie Data Act ma zastosowanie także do pojazdów używanych?</h2>
          <p>Tak. Przepisy dotyczą pojazdów z usługami łączności, zarówno nowych, jak i z rynku wtórnego.</p>
        </div>
        <div class="row">
          <h2>Skargi</h2>
          <p>Jeśli uważasz, że prawa przysługujące Ci na podstawie Rozporządzenia Data Act zostały naruszone, możesz – zgodnie z Artykułem 37 Rozporządzenia – złożyć skargę do odpowiedniego organu.</p>
        </div>
      </div>
    </div>

  </div>
</div>
